import { render, staticRenderFns } from "./tabs-type.vue?vue&type=template&id=4f22fc3c&scoped=true"
import script from "./tabs-type.vue?vue&type=script&lang=js"
export * from "./tabs-type.vue?vue&type=script&lang=js"
import style0 from "./tabs-type.vue?vue&type=style&index=0&id=4f22fc3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22fc3c",
  null
  
)

export default component.exports